import { RecruitingInterviewStatics } from '../../../../../store/workspace/types';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import { useDispatch } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';
import { useState } from 'react';
import {
    setVideoSrc,
    setVideoSubtitleSrc,
    setVideoPlayerModal,
} from '../../../../../store/workspace/slice';
import {
    CheckSolidIcon,
    ChevronUpIcon,
    EmptyStateIcon,
    TimesSolidIcon,
    ChevronDownIcon,
    NotApplicableIcon,
} from '../../../../../assets/icons';

const columnKeys = [
    'culturalFit',
    'communicationSkills',
    'problemSolvingAbility',
    'teamCollaboration',
    'timeManagement',
    'selfMotivation',
    'multitaskingAbility',
    'taskPrioritization',
    'productivity',
];

interface Props {
    applicantId: string | undefined;
    interviewData: RecruitingInterviewStatics | null;
};

export default function RecruitingInterviewResults(props: Props) {
    const dispatch = useDispatch();
    const { applicantId, interviewData } = props;
    const [openedAcordions, setOpenedAcordions] = useState<number[]>([]);
    const applicantDetail = interviewData?.examiners.find(item => item.userId === applicantId);

    const manageAcordions = (index: number) => {
        const check = openedAcordions.findIndex(i => i === index);
        if (check === -1) {
            setOpenedAcordions(prev => [...prev, index]);
        } else {
            setOpenedAcordions(prev => prev.filter(i => i !== index));
        }
    };

    const renderResult = (res: 'True' | 'False' | 'Not Applicable') => {
        switch (res) {
            case 'True':
                return <CheckSolidIcon />;
            case 'False':
                return <TimesSolidIcon />;
            case 'Not Applicable':
                return <NotApplicableIcon />;
            default:
                return ''
        }
    };

    const openVideoPlayer = (src: string, subtitle: string) => {
        dispatch(setVideoSrc(src));
        dispatch(setVideoSubtitleSrc(subtitle));
        dispatch(setVideoPlayerModal(true));
    };

    return (
        <MotionWrapper className={styles.container}>
            {!applicantDetail ? <div className={styles.empty_state}>
                <EmptyStateIcon />
                <span>No data.</span>
            </div> : <div className={styles.main}>
                <div className={styles.header}>
                    <span className={styles.header_item}>
                        Applicant name : {applicantDetail?.first_name} {applicantDetail?.last_name}
                    </span>
                    <span className={styles.header_item}>
                        Question quantities : {interviewData?.exam.countQuestions}
                    </span>
                    <span className={styles.header_item}>
                        Interview time : {(interviewData?.exam.countQuestions || 0) * 5}’
                    </span>
                </div>
                <div className={styles.question_data}>
                    <table>
                        <thead>
                            <tr>
                                <th>Cultural Fit</th>
                                <th>Communication Skills</th>
                                <th>Problem-Solving Ability</th>
                                <th>Team Collaboration</th>
                                <th>Time Management</th>
                                <th>Self Motivation</th>
                                <th>Multitasking Ability</th>
                                <th>Task Prioritization</th>
                                <th>Productivity</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {columnKeys.map((col) => {
                                    const matchedItem = applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === col);
                                    return <td key={col}>{matchedItem ? renderResult(matchedItem.result) : 'N/A'}</td>;
                                })}
                            </tr>
                        </tbody>
                    </table>

                    <div className={styles.card}>
                        <div className={styles.card_body}>
                            <div className={styles.card_body_section}>
                                <div className={styles.card_body_section_title}>
                                    Criteria
                                </div>
                                <div className={styles.card_body_section_content}>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Cultural Fit</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'culturalFit')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Communication Skills</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'communicationSkills')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Problem-Solving Ability</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'problemSolvingAbility')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Team Collaboration</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'teamCollaboration')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Time Management</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'timeManagement')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Self Motivation</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'selfMotivation')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Multitasking Ability</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'multitaskingAbility')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Task Prioritization</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'taskPrioritization')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section_content_item}>
                                        <span>Productivity</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            {renderResult(applicantDetail?.evaluatedCriteria?.find((item) => item.nameKey === 'productivity')?.result || 'Not Applicable')}
                                            <span>Report</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {applicantDetail?.answerAnalysis?.map((item, indx) => <div className={styles.section}>
                        <div className={styles.section_question}>
                            <span>Question {indx + 1}:</span>
                            <span>{interviewData?.exam.questions[indx].question}</span>
                        </div>
                        <div className={styles.accordion}>
                            <div
                                className={styles.accordion_header}
                                onClick={() => manageAcordions(indx)}
                            >
                                <span>Summary</span>
                                {openedAcordions.some(i => i === indx) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </div>
                            {openedAcordions.some(i => i === indx) &&
                                <pre className={styles.accordion_body}>
                                    {item.summary}
                                </pre>}
                        </div>
                        <div className={styles.accordion}>
                            <div
                                className={styles.accordion_header}
                                onClick={() => manageAcordions(indx + 12)}
                            >
                                <span>Feedback</span>
                                {openedAcordions.some(i => i === indx + 12) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </div>
                            {openedAcordions.some(i => i === indx + 12) &&
                                <pre className={styles.accordion_body}>
                                    {item.feedback}
                                </pre>}
                        </div>
                        <div className={styles.accordion}>
                            <div className={styles.accordion_header}>
                                <span>Applicant Video:</span>
                                <Button
                                    type='Primary'
                                    text='Open Player'
                                    className={styles.accordion_body_open_video}
                                    onClick={() => openVideoPlayer(item.file, item.subtitle)}
                                />
                            </div>
                        </div>
                    </div>)}
                </div>
            </div>}
        </MotionWrapper>
    )
};
